import React, { ComponentPropsWithRef } from "react";
import { cx } from "@emotion/css";

interface IncAlertCounterProps extends ComponentPropsWithRef<any> {
  alertCount: number;
  disable?: boolean;
  onClick?: () => void;
  className?: string;
}

export const IncAlertCounter = React.forwardRef<HTMLDivElement, IncAlertCounterProps>((props, ref) => {
  const { alertCount, children, disable, onClick, className } = props;
  const alertIconClassName = cx({
    "alert-icon-wrapper": true,
    active: alertCount > 0,
    disableClick: disable
  });

  const customClassName = className ?? "";
  const alertCountStr = alertCount > 99 ? "99+" : alertCount.toString();

  return (
    <div>
      <div
        className={`${alertIconClassName} ${customClassName}`}
        data-alerts-count={alertCountStr}
        onClick={onClick}
        ref={ref}
      >
        {children}
      </div>
    </div>
  );
});
